import React from 'react';

import '../Styles/Components/AppBanner.scss';

export default function AppBanner(props) {
    // console.log("showheadline: ", props.showheadline);

    var appBannerStyling = {
        backgroundColor: props.backgroundcolor ? props.backgroundcolor : 'white',
        backgroundImage: "url('" + props.bannerbgsrc + "')",
        backgroundRepeat: 'no-repeat',
        backgroundSize: 'cover',
        minHeight: '24em'
    };

    return (
        <div style={props.style} className="AppBanner--Banner">

            {
                props.showheadline ?
                    <div className="AppBanner--Banner--Headline">
                        <p className="AppBanner--Banner--Headline--Title">{props.title}</p>
                        <p className="AppBanner--Banner--Headline--Tagline">{props.tagline}</p>
                    </div> : null
            }

            {
                props.bannerimgsrc ?
                    <img
                        alt="The Wall Cover"
                        src={props.bannerimgsrc}
                        style={props.coverImgStyle}
                        className="AppBanner--Banner--Image img-fluid"
                    /> : null
            }
            {
                props.bannerbgsrc ?
                    <div style={appBannerStyling}>
                    </div> : null
            }

        </div>
    )
}